module.exports = __webpack_public_path__ + "static/img/base.12dbd75c.png";